<template>
    <section class="notice-box" role="note">
        <svg class="notice-box__icon" viewBox="0 0 20 20" aria-hidden="true">
            <circle cx="10" cy="10" r="10" fill="#ffb800" />
            <rect x="9" y="4.5" width="2" height="7.5" rx="1" fill="#664d03" />
            <circle cx="10" cy="14.75" r="1.25" fill="#664d03" />
        </svg>
        <section class="notice-box__content">
            <span v-if="title" class="notice-box__title">{{ title }}</span>
            <span v-if="text || $slots.default" class="notice-box__text"><slot>{{ text }}</slot></span>
        </section>
    </section>
</template>
<script charset="utf-8">
    /**
     * Wyrozniona informacja, np. wymaganie przed konfiguracja - zolta ramka z wykrzyknikiem.
     * Komponent nie ma wlasnych tekstow: tytul i tresc podaje rodzic (z $t), a tresc
     * z formatowaniem albo linkiem mozna przekazac w domyslnym slocie zamiast propsa text.
     */
    export default {
        name: "NoticeBox",
        props: {
            title: String,
            text: String
        }
    }
</script>
<style lang="scss" scoped>
    .notice-box {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 10px;
        padding: 10px 12px;
        color: #664d03;
        background: #fff3cd;
        border: 1px solid #ffecb5;
        border-left: 4px solid #ffb800;
        border-radius: 4px;

        &__icon {
            flex-shrink: 0;
            width: 20px;
            height: 20px;
        }

        &__content {
            display: flex;
            flex-direction: column;
            gap: 4px;
            min-width: 0;
        }

        &__title {
            font-size: 13px;
            font-weight: 600;
            line-height: 20px;
        }

        &__text {
            font-size: 12px;
            line-height: 1.4;
        }
    }
</style>
